import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import SaveAltIcon from "@mui/icons-material/SaveAlt";

const ExportButton = ({ onExportCsv, onExportJson, disabled }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleExport = (exportFn) => () => {
    handleClose();
    exportFn();
  };

  return (
    <>
      <Button
        size="small"
        startIcon={<SaveAltIcon />}
        aria-haspopup="menu"
        aria-expanded={open ? "true" : undefined}
        onClick={handleOpen}
        disabled={disabled}
      >
        Export
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {onExportCsv && <MenuItem onClick={handleExport(onExportCsv)}>Export CSV</MenuItem>}
        {onExportJson && (
          <MenuItem onClick={handleExport(onExportJson)}>Export JSON</MenuItem>
        )}
      </Menu>
    </>
  );
};

ExportButton.propTypes = {
  onExportCsv: PropTypes.func,
  onExportJson: PropTypes.func,
  disabled: PropTypes.bool,
};

export default ExportButton;
